module.exports = __webpack_public_path__ + "assets/popup-icon.svg";


//////////////////
// WEBPACK FOOTER
// ./images/icons/popup-icon.svg
// module id = 818
// module chunks = 0